"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var editableTable_1 = require("./editableTable");
exports.default = {
    editableTable: editableTable_1.editableTable,
};
//# sourceMappingURL=index.js.map